import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class VoucherListValueComponent extends Component {
  @tracked selectVoucher = null;
}
